import PropTypes from "prop-types";
import React, { Component } from "react";
import { DatePicker } from "react-md/lib/Pickers";
import { dateToString } from "components/Shared/Formatters";

class DatePicker2Field extends Component {
  constructor(props) {
    super(props);
    this.clearDate = this.clearDate.bind(this);
  }

  clearDate(event) {
    event.preventDefault();
    let newDate = null;
    this.props.input.onChange(newDate);
  }

  render() {
    let hasValue = this.props.input.value;
    hasValue = hasValue.length > 0 && hasValue.indexOf("0001-01-01") == -1; // check for J bday
    return (
      <div style={{ position: "relative" }}>
        <DatePicker
          {...this.props}
          className={this.props.containerClassName}
          onChange={this.props.input.onChange}
          name={this.props.name}
          autoOk
          value={dateToString(this.props.input.value)}
          dateTimeFormat={dateToString}
          fullWidth={false}
          inline
          displayMode="portrait" />
        {hasValue &&
          <i className="md-icon material-icons md-date-picker-clear"
            onClick={this.clearDate}
            style={{ position: "absolute", top: "26px", left: "180px", padding: "0", width: "24px", height: "24px" }} >
            delete_forever
          </i>}
      </div>
    );
  }
}

DatePicker2Field.propTypes = {
  input: PropTypes.object.isRequired,
  name: PropTypes.string,
  containerClassName: PropTypes.string
};
export default DatePicker2Field;